/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { DrillInDialog } from "./drill_in_dialog";
import { DailyLogbookMetricPanel } from "./metric_panel";
import { DailyLogbookSections } from "./sections";

/**
 * One revenue center, opened from the rail in the restaurant modal. Everything it shows
 * already arrived with the restaurant payload, so opening it costs no extra request.
 */
export const RevenueCenterModal = ({ open, center, restaurantName, businessDateLabel, onClose }) => (
  <DrillInDialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    testId="daily-logbook-revenue-center-modal"
    title={center?.name}
    subtitle={[restaurantName, businessDateLabel].filter(Boolean).join(" · ")}
    left={
      <DailyLogbookMetricPanel
        title="Performance Snapshot"
        metrics={center?.metrics || []}
        testIdPrefix="daily-logbook-revenue-center"
      />
    }
    right={
      <DailyLogbookSections
        sections={center?.sections}
        testIdPrefix="daily-logbook-revenue-center"
      />
    }
  />
);
